import { useMemo, useState } from 'react';
import { androidStoreUrl, getIosStoreUrl } from 'utils/app-store-links';

const DISMISSED_KEY = 'mobileAppBannerDismissed';

type MobilePlatform = 'ios' | 'android';

const getMobilePlatform = (userAgent: string): MobilePlatform | null => {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';
  return null;
};

const getCountryCode = (): string => {
  const locale = navigator.languages?.[0] || navigator.language || '';
  return locale.split('-')[1]?.toUpperCase() || '';
};

export function useMobileAppBanner() {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISSED_KEY) === 'true');
  const platform = useMemo(() => getMobilePlatform(navigator.userAgent), []);
  const storeUrl = useMemo(() => {
    if (platform === 'ios') return getIosStoreUrl(getCountryCode());
    if (platform === 'android') return androidStoreUrl;
    return null;
  }, [platform]);

  const dismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, 'true');
    setDismissed(true);
  };

  return {
    isVisible: !!platform && !dismissed,
    storeUrl,
    dismiss,
  };
}
